import { jsonpCallbackContext } from '@angular/common/http/src/module';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule, FormArray, FormBuilder } from '@angular/forms';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '../services/global.service';
import Utils from '../shared/utility';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-new-illustration-hc-questionnaire',
  templateUrl: './new-illustration-hc-questionnaire.component.html',
  styleUrls: ['./new-illustration-hc-questionnaire.component.css']
})
export class NewIllustrationHcQuestionnaireComponent implements OnInit {
  clientSpouseFullName: string;
  clientFirstName: string;
  spouseFirstName: string;
  isMarried: boolean;

  healthInsuranceForm: FormGroup;
  spouseHealthInsuranceForm: FormGroup;
  medicareCoverageForm: FormGroup;
  spouseMedicareCoverageForm: FormGroup;
  additionalQuestionsForm: FormGroup;
  incomeRangeSelectionForm: FormGroup;
  incomeEntryForm: FormGroup;
  additinalIncomeForm: FormGroup;
  magiProjectionForm: FormGroup;

  isHealthInsurance: boolean;
  isMedicareCoverage: boolean;
  isSpouseHealthInsurance: boolean;
  isSpouseMedicareCoverage: boolean;
  isTraditinalPremium: boolean;
  isHMOMedicareAdvantage: boolean;
  isPPOMedicareAdvantage: boolean;
  isSpouseTraditinalPremium: boolean;
  isSpouseHMOMedicareAdvantage: boolean;
  isSpousePPOMedicareAdvantage: boolean;
  isAdditionalQuestion: boolean;
  isEnableUpdateButton: boolean = false;
  isIncomeSelection: boolean;
  isIncomeRangeSelection: boolean;
  isIncomeEnter: boolean;
  isOptionEnter: boolean;
  isOptionCurrentIncome: boolean;
  houseHoldYearOneIncome: any;
  isOptionYearOneRetIncome: boolean;
  isAdditionalIncome: boolean;
  isMAGIProjection: boolean;
  isEditPercentMAGI: boolean;
  isSpouseSameHCSelection: boolean = false;
  isMAGIUpdate: boolean = false;
  isShowSpouse: boolean = false;
  isIncomeSelectionCard: number;
  isEditAll: boolean = false;
  isPre65: boolean;
  isSpousePre65: boolean;
  isSSFilledBefore: boolean = false;
  isSpouse: boolean = false;
  isClient: boolean = false;
  isLegalMarried: boolean = false;
  couplePassesAwaySameYear: boolean = false;
  featAdditionalQuestions: boolean = false;

  magiBracketOneMin: number;
  magiBracketOneMax: number;
  magiBracketTwoMin: number;
  magiBracketTwoMax: number;
  magiBracketThreeMin: number;
  magiBracketThreeMax: number;
  magiBracketFourMin: number;
  magiBracketFourMax: number;
  magiBracketFiveMin: number;
  magiBracketFiveMax: number;
  magiBracketSixMin: number;
  magiBracketSixMax: string;
  isSocialSecurityEdit: boolean;
  previousEnteredHousholdIncome: number;
  isHouseholdIncomeDivide: boolean;
  isClientInExemptState: boolean;
  isSpouseInExemptState: boolean;

  // mmtModalData = [];

  public client: any;

  public ssClientAge: string = '65';
  public ssSpouseAge: string = '65';
  public magi: number = 100;

  public mmtModalData: any[];
  public mmtModalDataPass = [];
  public startingIllustration: any[];

  params: any;


  private navCards = [
    { title: 'Select', subtitle: 'Income Bracket Range', description: 'Medicare surcharge bracket consistent through retirement',  source: 'fromIncomeSource' },
    { title: 'Calculate', subtitle: 'Projected Retirement Income', description: 'Medicare surcharge re-evaluated annually',  source: 'fromIncomeEnter' },
  ]

  //public currentHouseholdIncomeMessage: string = "This amount is pre-populated based on user inputs but may be overridden.";
  //public incomeInflationRateMessage: string = "The annual rate at which household income is projected to grow in future pre-retirement years.";
  //public incomeReplacementRatioMessage: string = "The percentage of pre-retirement income that the household will require in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  public inRetInflationRateMessage: string = "The annual rate at which household income is projected to grow in future retirement years.";
  public percentOfIncomeMAGIMessage: string = "The share of gross retirement income that is anticipated to fall under Modified Adjusted Gross Income (MAGI).";
  public householdIncomeYearOneMessage: string = "This amount is calculated based on the values to the left but may be overridden.";
  public currentHouseholdIncomeMessage: string = "This amount is pre-populated based on user inputs but may be overridden.";
  public currentGrossMonthlyBenefit: string = "Please enter the monthly benefit the client receives before taxes and Medicare withholdings.";
  public incomeInflationRateMessage: string = "The annual rate at which household income is projected to grow in future pre-retirement years.";
  public incomeReplacementRatioMessage: string = "The percentage of pre-retirement income that the household will require in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  public substantialEarningMsg: string = "Social Security measures Substantial Earnings Years by the amount of money an individual earns in a calendar year on income that is taxed by Social Security. This metric is needed to calculate deductions made to the client’s Social Security benefit by the Windfall Elimination Provision. A chart with these measures for each year can be found at http://www.ssa.gov/pubs/EN-05-10045.pdf.";
  public midRetirementAdjustmentOptionalMessage: string = "Some retirees adjust their standard of living (upward or downward) during their retirement. To account for such a change to this retirement income projection, enter the information requested in the fields below.";
  public previousYearSSAMessage: string = "If taken from a previous year’s statement, add applicable recent COLAs to the amount: 2022 COLA: 8.7%; 2021 COLA: 5.9%; 2020 COLA: 1.3%; 2019 COLA: 1.6%; 2018 COLA: 2.8%."
  public expectedClaimAgeMessage: string = "Former spouse’s claim age may impact survivor benefits.";// Unsure of the anticipated claim age? The ex-spouse’s Full Retirement Age (FRA) is defaulted as the input.";
  public defaultIncomeInflationRate = '3.00%';
  public defaultIncomeReplacementRatio = '75%';
  constructor(private router: Router, private route: ActivatedRoute, public globalService: GlobalService, private loadingService: LoadingService) {

    this.params = (this.router.getCurrentNavigation().extras.state) ? this.router.getCurrentNavigation().extras.state.params : '';
    this.featAdditionalQuestions = localStorage.getItem('featAdditionalQuestions') == 'true' ? true: false;
    console.log('this.params', this.params);
        
    if (this.params == 'medCoverage') {
      // this.resetFormBooleanValue();
      this.isMedicareCoverage = true;
      this.isEnableUpdateButton = true;

    } else if (this.params == 'pre65') {
      this.isEnableUpdateButton = true;
      this.isHealthInsurance = true;
    }  else if (this.params == 'income') {
      this.isEnableUpdateButton = true;
      this.isIncomeSelection = true;
    } else if (this.params == 'additionalQuestions') {
      // this.resetFormBooleanValue();
      this.isAdditionalQuestion = true;
      this.isEnableUpdateButton = true;
    } else {
      if (this.params == 'editAll' || this.params == '') {
        
        this.isEditAll = true;
      }
      this.isHealthInsurance = true;
    }


    this.healthInsuranceForm = new FormGroup({
      IsPrivateHealthInsurance: new FormControl('', Validators.required),
      CoverageType: new FormControl('')
    });

    this.spouseHealthInsuranceForm = new FormGroup({
      IsSpousePrivateHealthInsurance: new FormControl('', Validators.required),
      SpouseCoverageType: new FormControl('')
    });

    this.medicareCoverageForm = new FormGroup({
      HealthCarePremiumType: new FormControl('', Validators.required),
      MedicarePartB: new FormControl(true),
      MedicarePartD: new FormControl(true),
      SupplimentalInsurance: new FormControl(false),
      SupplementalPlan: new FormControl('G'),
      MedicareAdvantageHMO: new FormControl(true),
      MedicareAdvantagePPO: new FormControl(true),
      DentalInsurance: new FormControl(false),
      HospitalAndTest: new FormControl(false),
      PrescriptionDrugs: new FormControl(false),
      HearingAndVisionCosts: new FormControl(false),
      DentalCosts: new FormControl(false),
      IsSpouseSameHCSelection: new FormControl(false)

    });

    this.spouseMedicareCoverageForm = new FormGroup({
      SpouseHealthCarePremiumType: new FormControl('', Validators.required),
      SpouseMedicarePartB: new FormControl(true),
      SpouseMedicarePartD: new FormControl(true),
      SpouseSupplimentalInsurance: new FormControl(false),
      SpouseSupplementalPlan: new FormControl('G'),
      SpouseMedicareAdvantageHMO: new FormControl(true),
      SpouseMedicareAdvantagePPO: new FormControl(true),
      SpouseDentalInsurance: new FormControl(false),
      SpouseHospitalAndTest: new FormControl(false),
      SpousePrescriptionDrugs: new FormControl(false),
      SpouseHearingAndVisionCosts: new FormControl(false),
      SpouseDentalCosts: new FormControl(false)
    });

    this.additionalQuestionsForm = new FormGroup( {
      Firm: new FormControl(),
      Wholesaler: new FormControl(),
      RepName: new FormControl(),
      PlanSponsor: new FormControl(),
      SendReportTo: new FormControl(),
      MeetingReference: new FormControl(),
      ReportRequestFrom: new FormControl()
    })

    this.incomeRangeSelectionForm = new FormGroup({
      BracketValue: new FormControl(0, [])
    });


    this.incomeEntryForm = new FormGroup({
      HouseHoldIncome: new FormControl('', [Validators.min(0), Validators.max(5000000)]),
      IncomeInflationRate: new FormControl(this.defaultIncomeInflationRate, [Validators.required, Validators.min(0), Validators.max(10)]),
      IncomeReplacementRatio: new FormControl(this.defaultIncomeReplacementRatio, [Validators.required, Validators.min(50), Validators.max(200)]),//min 50 - max 200
      YearOneRetirementIncome: new FormControl()
    });

    this.additinalIncomeForm = new FormGroup(
      {
        InRetInflationRate:  new FormControl('2.4%', [Validators.required, Validators.min(-5), Validators.max(10)]),
        MAGIPerc: new FormControl('100%', [Validators.required, Validators.min(0), Validators.max(100)]),
        RetAdjYear: new FormControl('',[Validators.maxLength(4)]),
        RetAdjReductionDollar: new FormControl(),
        RetAdjReductionPerc: new FormControl(),
        RetAdjReductionInflation: new FormControl()
      }
    )

    this.magiProjectionForm = new FormGroup(
      {
        mmtModalDataItems: new FormArray([])
      }
    )

      //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

  }

  ngOnInit() {
    this.loadingService.isLoading(true);
    this.isOptionCurrentIncome = true;
    this.getClient();
  }

 
modalDataItems() {
  return this.magiProjectionForm.get("mmtModalDataItems") as FormArray
}

  populateForm() {
    const control = <FormArray>this.magiProjectionForm.controls['mmtModalDataItems'];
    // let k = [{'year': '2057', 'age': '--/78',  'fullMAGI': '$0','percentMAGI': '2057', 'updatedBracket':1}]
    // the data you have received, for each object create a form group
    this.mmtModalData.forEach(item => {
      control.push(this.initItems(item))
    });

    this.loadingService.isLoading(false);
  }
  
  initItems(item) {
    // create a formgroup for each item
    return new FormGroup({
      year: new FormControl([item.year]), // set required or whatever else
      age: new FormControl([item.age]),
      fullMAGI: new FormControl([item.fullMAGI]),
      percentMAGI: new FormControl([item.percentMAGI]),
      updatedBracket: new FormControl([item.updatedBracket]),
    })
  }


  next(scenario) {
    this.resetFormBooleanValue();
    console.log('scenario', scenario)
    if (scenario == 'healthInsuranceForm') {
      console.log('healthInsuranceForm 01');
      console.log('this.isShowSpouse', this.isShowSpouse);
      console.log('this.isSpousePre65', this.isSpousePre65)
      console.log('this.isEnableUpdateButton', this.isEnableUpdateButton)
      if (this.isShowSpouse && this.isSpousePre65 && this.isEnableUpdateButton) {
        console.log('healthInsuranceForm 02')
        if (this.isSpouseSameHCSelection) {
          this.isSpouseHealthInsurance = false;
        } else {
          this.isSpouseHealthInsurance = true;
        }
        
        this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].setValue(this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance);
        // this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance = this.healthInsuranceForm.value.IsPrivateHealthInsurance;
        this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].setValue(this.spouseHealthInsuranceForm.value.SpouseCoverageType);
        // this.spouseHealthInsuranceForm.value.SpouseCoverageType = this.healthInsuranceForm.value.CoverageType;
      } else {
        console.log('this.isMedicareCoverage')
        this.isMedicareCoverage = true;
        // let isPrivateHealthInsurance = this.healthInsuranceForm.value.IsPrivateHealthInsurance;
        // if (isPrivateHealthInsurance == 'true') {
        //   this.isMedicareCoverage = true;
        // } else {
        //   this.isIncomeSelection = true;
        // }
      }

    }
    if (scenario == 'medicareCoverageForm') {
      console.log('inside medicareCoverageForm');
      if (this.params == 'medCoverage' && !this.isSpouseSameHCSelection) {
        this.client.clientProfile.IsHSApplySpouse = false;
        this.isEnableUpdateButton = true;
      }
      
      if (this.isEnableUpdateButton && this.isShowSpouse && !this.isSpouseSameHCSelection) {
        this.isSpouseMedicareCoverage = true;
        this.changeSelection(this.isShowSpouse);
      } else {
        if (this.isMarried && !this.isSpouseSameHCSelection) {
          console.log('this.isSpouseSameHCSelection', this.isSpouseSameHCSelection)
          console.log('this.isPre65', this.isPre65)
          console.log('this.isSpousePre65', this.isSpousePre65)
          // this.isSpouseHealthInsurance = true;
          if (this.isPre65 && this.isSpousePre65) {
            this.isSpouseHealthInsurance = true;
            // this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].setValue(this.healthInsuranceForm.value.IsPrivateHealthInsurance);
            // this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].setValue(this.healthInsuranceForm.value.CoverageType);
          } else {
            this.isSpouseHealthInsurance = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false: true): true;
          }
          
          console.log('this.isSpouseHealthInsurance', this.isSpouseHealthInsurance);
          this.isSpouseMedicareCoverage = !this.isSpouseHealthInsurance ? true : this.isSpouseMedicareCoverage;
          console.log('this.isSpouseMedicareCoverage', this.isSpouseMedicareCoverage)
        } else {
          if (this.isMarried && !this.isPre65 && this.isSpousePre65) {
            this.isSpouseHealthInsurance = true;
            // this.isSpouseHealthInsurance = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false: true): true;
            // this.isSpouseMedicareCoverage = !this.isSpouseHealthInsurance ? true : this.isSpouseMedicareCoverage;
          } else if (this.isSSFilledBefore && !this.client.clientProfile.Bracket) {
            this.isIncomeEnter = true;

            this.isOptionCurrentIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate != null && this.client.clientProfile.IRR) ? true : false;
            // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
            this.houseHoldYearOneIncome = this.client.clientProfile.HouseholdYearOneIncome ? this.client.clientProfile.HouseholdYearOneIncome : '';
            let currentIncome = (Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0));
              console.log('currentIncome log', currentIncome);
              console.log('this.isOptionCurrentIncome', this.isOptionCurrentIncome)
              if (this.isOptionCurrentIncome) {
                // this.selectOptions('currentIncome');
                console.log('currentIncome log2', currentIncome);
                console.log('this.incomeEntryForm.value.IncomeReplacementRatio', this.incomeEntryForm.value.IncomeReplacementRatio);
                console.log('this.defaultIncomeInflationRate', this.defaultIncomeInflationRate)
                console.log('this.client.clientProfile.IRR', this.client.clientProfile.IRR)
                this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
                //  this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);
                this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);

                this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);
                if (this.client.clientProfile.HouseholdYearOneIncome) {
                 this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
                 this.isOptionCurrentIncome = false;
                }
              } else {
                // this.selectOptions('houseHoldIncome');
              //  this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
                this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
                this.incomeEntryForm.controls['IncomeInflationRate'].setValue('3%');
                this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);
                this.isOptionCurrentIncome = true;
              }
          } else {
            this.isIncomeSelection = true;
          }

        }
      }
    }
    if (scenario == 'spouseHealthInsuranceForm') {
      // this.isSpouseMedicareCoverage = true;
      if(this.params == "pre65") {
        this.isSpouseHealthInsurance = true;
      } else {
        if (!this.isSpouseSameHCSelection) {
          this.isSpouseMedicareCoverage = true;
        } else {
          if (this.isSSFilledBefore && !this.client.clientProfile.Bracket) {
            console.log('currentIncome log', 22);
            this.isIncomeEnter = true;
            if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
            } else {
              let currentIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0);
              console.log('currentIncome', currentIncome)
              this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
            }
          } else {
            this.isIncomeSelection = true;
          }
        }
      }
    }

    if (scenario == 'spouseMedicareCoverageForm') {
      // this.isIncomeSelection = true;
      console.log('currentIncome log', 2);
      if (this.isSSFilledBefore && !this.client.clientProfile.Bracket) {
        console.log('currentIncome log', 22);
        this.isIncomeEnter = true;
        if (this.client.clientProfile.HouseholdYearOneIncome) {
         this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
        } else {
          let currentIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0);
          console.log('currentIncome', currentIncome)
          this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
        }
      } else {
        this.isIncomeSelection = true;
      }
    }
    
    if (scenario == 'incomeSelectionForm' && (this.params == 'income'  || this.isEditAll)) {
      console.log('scenario', scenario)
      console.log('currentIncome log', 0);
      console.log('this.isOptionCurrentIncome', this.isOptionCurrentIncome)
      console.log('this.houseHoldYearOneIncome', this.houseHoldYearOneIncome)

      // this.isIncomeSelectionCard
      if (this.isIncomeSelectionCard == 1) {
        let currentIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0); 
        if (this.isOptionCurrentIncome) {
          console.log('here i am 01');
          console.log('this.client', this.client)
          this.isIncomeEnter = true;
          this.isOptionEnter = true;
                 
          console.log('currentIncome', currentIncome)
          this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
           this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);
          this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);
          if (this.houseHoldYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
          }
        } else {
        //   this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome && currentIncome > 0 ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
        //   this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);
        //  this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);
        this.isIncomeEnter = true;
         this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);

        }

      } else {
        console.log('here i am 02');
        this.isIncomeEnter = this.isOptionEnter = false;
        this.isIncomeRangeSelection = true;
      }

      
      console.log('bracket on next new person', this.incomeRangeSelectionForm.value);
    }
    if (scenario == 'incomeRangeSelectionForm') {
      this.isAdditionalQuestion = true;
    }
    if (scenario == 'additionalQuestionsForm') {
      this.updateClientProfileWithHCQuestionnaire();
      localStorage.setItem('isHCQuestionnaireFilled', 'true');
      
      if(this.globalService.featQuickReports){
        //if Quick is enabled for Org, go to options on how to serve illustration
        this.router.navigate(['/clients/edit/healthcare/options']);
      } else {
        //go directly to HC illustration on-screen
        this.router.navigate(['/clients/edit/healthcare/options/hc']);
      }
    }
    if (scenario == 'Select') {
      this.isIncomeSelectionCard = 2;
      this.isIncomeRangeSelection = true;
      this.isOptionEnter = false;
      this.isMAGIUpdate = false;
      if (this.client.clientProfile.Bracket) {
        this.incomeRangeSelectionForm.controls['BracketValue'].setValue(this.client.clientProfile.Bracket.toString());
      }
    }
    if (scenario == 'Calculate') {
      this.isIncomeSelectionCard = 1;
      this.client.clientProfile.Bracket = null;
      this.incomeRangeSelectionForm.controls['BracketValue'].setValue('');

      this.isIncomeEnter = true;
      this.isOptionEnter = true;
      this.isOptionCurrentIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate != null && this.client.clientProfile.IRR) ? true : false;
      // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
      this.houseHoldYearOneIncome = this.client.clientProfile.HouseholdYearOneIncome ? this.client.clientProfile.HouseholdYearOneIncome : '';
       let currentIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0);      
        if (this.isOptionCurrentIncome) {
          // this.selectOptions('currentIncome');
          this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(currentIncome): this.incomeEntryForm.value.HouseHoldIncome);
           this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);
          this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);

          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
            this.isOptionCurrentIncome = false;        
           }
        } else {
          // this.selectOptions('houseHoldIncome');
          this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
        }
    }
    if (scenario == 'incomeEntryForm') {
      this.isAdditionalIncome = true;
    }
    if (scenario == 'additinalIncomeForm') {
      // this.isMAGIProjection = true;
      this.isAdditionalQuestion = true;
    }
    if (scenario == 'magiProjectionForm') {
      this.isAdditionalQuestion = true;
    }

  }

  formatCurrency(amount, scenario) {
    // console.log('amount', amount);
    if (scenario == '') {
      return Utils.formatToCurrency(amount)
    } else {
      console.log('amount', amount);
      amount = amount.replace(/\D/g, '');
      if (amount != '') {
        amount = amount.toString().replace(/,/g, "").replace("$", "");
        if (scenario == 'houseHoldIncome') {
          if (amount > 5000000) {
            this.incomeEntryForm.controls['HouseHoldIncome'].setErrors({'incorrect': true});
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(amount));
            // console.log('isSocialSecurityEdit', this.isSocialSecurityEdit)
            // console.log('this.previousEnteredHousholdIncome', this.previousEnteredHousholdIncome)
            // if (this.isSocialSecurityEdit && this.previousEnteredHousholdIncome != amount) {
            //   this.isHouseholdIncomeDivide = true;
            // } else {
            //   this.isHouseholdIncomeDivide = false;
            // }
          }
        }
        if (scenario == 'yearOneRetirementIncome') {
          console.log('amount', amount);
          this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(amount));
        }
        if (scenario == 'retAdjReductionDollar') {
          if (this.additinalIncomeForm.value.RetAdjReductionPerc && amount) {
            this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
          }
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue(Utils.formatToCurrency(amount));
        }
  
      } else {
        if (scenario == 'houseHoldIncome') {
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue('');
        }
        if (scenario == 'yearOneRetirementIncome') {
          this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue('');
        }
      }
    }


  }

  onFocusOutEvent(event) {
    console.log('isSocialSecurityEdit', this.isSocialSecurityEdit)
    console.log('this.previousEnteredHousholdIncome', this.previousEnteredHousholdIncome)
    let amount = this.incomeEntryForm.value.HouseHoldIncome;
    amount = amount.replace(/\D/g, '');
    if (this.isSocialSecurityEdit && this.previousEnteredHousholdIncome != amount && this.isMarried) {
      this.isHouseholdIncomeDivide = true;
    } else {
      this.isHouseholdIncomeDivide = false;
    }
  }

  getDOBMonth(birthday){
    return new Date(birthday).getMonth() + 1;
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  calculateAgeAtMarriage(birthdate, marriageDate) {
    birthdate = new Date(birthdate);
    marriageDate = new Date(marriageDate);
    var diffYear = marriageDate.getFullYear() - birthdate.getFullYear();
    return diffYear
  }
  
  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('age',Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset)));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  boolSetYearAfterSpouse: boolean = false;
  setYearAfterSpouse(value){
    this.boolSetYearAfterSpouse = (this.boolSetYearAfterSpouse) ? false : true;
    //console.log('setYearAfterSpouse', this.boolSetYearAfterSpouse);

    //For married couples who do not pass away in the same year
    //When clicked, the year of first spouse death plus one is pre-populated into the “Year” input field. 
    if(this.boolSetYearAfterSpouse){
      this.additinalIncomeForm.controls['RetAdjYear'].patchValue(this.getFirstSpouseDeathPlusOne());
    } else {
      this.additinalIncomeForm.controls['RetAdjYear'].patchValue('');
    }

    this.client.clientProfile.Spouses[0].setYearAfterSpouse = this.boolSetYearAfterSpouse;
  }

  getFirstSpouseDeathPlusOne() {
    var clientPassYear = ((this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + new Date().getFullYear()) + 1;
    var spousePassYear = ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) + new Date().getFullYear()) + 1;
    return clientPassYear > spousePassYear ? spousePassYear : clientPassYear
  }

  formatMidRetDollar(amount, scenario) {
    if (scenario == '') {
      return Utils.formatToCurrency(amount)
    }

    // amount = amount.replace(/\D/g, '');
    amount = amount.replace(/(?!-)[^0-9.]/g, "");
    var newAmount = '';
    newAmount += amount.charAt(0);
    for (var i = 1; i < amount.length; i++) {
        
      if (amount.charAt(i) != '-') {
        console.log('char -');
        console.log('amount', amount);
        newAmount += amount.charAt(i);
        console.log('newAmount', newAmount);
        amount.toString().replace("-", "");
      } else {
        amount = newAmount;
      }
    }

    if (amount != '') {
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (scenario == 'retAdjReductionDollar') {
        if (this.additinalIncomeForm.value.RetAdjReductionPerc && amount) {
          this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
        }
        this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue(Utils.formatToCurrency(amount));
        this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
        this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
        this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();
      }
    } else {
      if (!this.additinalIncomeForm.value.RetAdjReductionPerc) {
        this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required])
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
      console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 01', this.additinalIncomeForm.value.RetAdjReductionDollar);
      if (!this.additinalIncomeForm.value.RetAdjReductionDollar) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 02', this.additinalIncomeForm.value.RetAdjReductionDollar);
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !Utils.removeCurrencyFormatting(this.additinalIncomeForm.value.RetAdjReductionDollar) && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }
    }

  }

  clearMidRetValidation() {
    this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjReductionDollar').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionDollar'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjReductionPerc').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionPerc'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjYear').clearValidators();
    this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();

  }

  formatMidRetPer(event, scenario) {
    const key = event.keyCode || event.charCode;
    var value = event.target.value;
    value = value.replace(/(?!-)[^0-9.]/g, "");
    var newValue = '';
    newValue += value.charAt(0);
    for (var i = 1; i < value.length; i++) {
        
      if (value.charAt(i) != '-') {
        console.log('char -');
        console.log('value', value);
        newValue += value.charAt(i);
        console.log('newValue', newValue);
        value.toString().replace("-", "");
      } else {
        value = newValue;
      }
    }
    var isDeleting = false;
    if(key === 8 || key === 46){
      isDeleting = true;
    }
    if (value != '') {
      if (scenario == 'retAdjReductionPerc') {
        if (this.additinalIncomeForm.value.RetAdjReductionDollar && value) {
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue('');
        }
        this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
        if (this.additinalIncomeForm.value.RetAdjReductionPerc) {
          this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
          this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
        }
        this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
      }
    } else {
      if (!this.additinalIncomeForm.value.RetAdjReductionDollar) {
        this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required])
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }

    }
  }

  formatPercentage(event, scenario, precision = 2) {
    const key = event.keyCode || event.charCode;
    var value = event.target.value.replace('%', '');
    var values = value.split('.')
    const isNegative = value.substring(0, 1) === '-'

    if (!(/\d/.test(value)) && !isNegative) {
      value = ''
    } else {
      if(value.includes('.')) {
        values[0] = isNegative ? values[0].replace(/\D+/g, '') * -1 : values[0].replace(/\D+/g, '');
        values[1] = values[1].replace(/\D+/g, '');
        value = `${values[0]}.${values[1].substring(0, precision)}`
      } else {
        if (value < 0)
          value = value;
        else
          value = value === '-' ? '-' : value.replace(/\D+/g, '');
      }
    }
    
    var isDeleting = false;
    if (key === 8 || key === 46) {
      isDeleting = true;
    }
    if (value != '') {
      console.log('value', value)
      if (scenario == 'incomeReplacementRatio') {
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'incomeInflationRate') {
        //this.incomeEntryForm.controls['IncomeInflationRate'].patchValue(Utils.formatToPercentage(value));
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'inRetInflationRate') {
        //this.additinalIncomeForm.controls['InRetInflationRate'].patchValue(Utils.formatToPercentage(value));
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'magiPerc') {
        //this.additinalIncomeForm.controls['MAGIPerc'].patchValue(Utils.formatToPercentage(value));
        this.additinalIncomeForm.controls['MAGIPerc'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'retAdjReductionPerc') {
        if (this.additinalIncomeForm.value.RetAdjReductionDollar && value) {
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue('');
        }
        this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue(Utils.formatToPercentage(value));
      }
      if (scenario == 'retAdjReductionInflation') {
        //this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue(Utils.formatToPercentage(value));
        if (this.additinalIncomeForm.value.RetAdjReductionInflation) {
          console.log('this.additinalIncomeForm.value.RetAdjReductionInflation 001', this.additinalIncomeForm.value.RetAdjReductionInflation);
          this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
        } 
        this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();
        if (!this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && this.additinalIncomeForm.value.RetAdjYear) {
          console.log('here i am');
          this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required]);
        } else {
          this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
        }
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
    } else {
      if (scenario == 'incomeReplacementRatio') {
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue('');
      }
      if (scenario == 'incomeInflationRate') {
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue('');
      }
      if (scenario == 'inRetInflationRate') {
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue('');
      }
      if (scenario == 'magiPerc') {
        this.additinalIncomeForm.controls['MAGIPerc'].patchValue('');
      }
      if (scenario == 'retAdjReductionPerc') {
        this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
      }
      if (scenario == 'retAdjReductionInflation') {
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue(null);
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }
    }

  }

  updateClientProfileWithHCQuestionnaire() {
    this.enableControls('client');
    let premiums = null;
    console.log('this.medicareCoverageForm', this.medicareCoverageForm)
    if(this.medicareCoverageForm.value.HealthCarePremiumType == 'TM'){
      premiums = {
        "MedicarePartB": this.medicareCoverageForm.value.MedicarePartB,
        "MedicarePartD": this.medicareCoverageForm.value.MedicarePartD,
        "SupplimentalInsurance": this.medicareCoverageForm.value.SupplimentalInsurance,
        "DentalInsurance": this.medicareCoverageForm.value.DentalInsurance
      }
      console.log('premiumns', premiums)
    } else if(this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO'){
      premiums = {
        "MedicareAdvantageHMO": this.medicareCoverageForm.value.MedicareAdvantageHMO,
        "DentalInsurance": this.medicareCoverageForm.value.DentalInsurance
      }
    } else if(this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO'){
      premiums = { 
        "MedicareAdvantagePPO": this.medicareCoverageForm.value.MedicareAdvantagePPO,
        "DentalInsurance": this.medicareCoverageForm.value.DentalInsurance
      }
    }

    let oopCosts = {
      "HospitalAndTest": this.medicareCoverageForm.value.HospitalAndTest,
      "PrescriptionDrugs": this.medicareCoverageForm.value.PrescriptionDrugs,
      "HearingAndVisionCosts": this.medicareCoverageForm.value.HearingAndVisionCosts,
      "DentalCosts": this.medicareCoverageForm.value.DentalCosts
    }

    let spousePremiums = null;
    let spouseOOPCosts = null;
    if (this.isMarried) {
      this.enableControls('spouse');
      
      this.client.clientProfile.IsHSApplySpouse = this.medicareCoverageForm.value.IsSpouseSameHCSelection;

      if(this.client.clientProfile.IsHSApplySpouse){
        this.spouseMedicareCoverageForm.controls['SpouseHealthCarePremiumType'].setValue(this.medicareCoverageForm.value.HealthCarePremiumType);
      }

      if(this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM'){
        console.log('this.spouseMedicareCoverageForm.value.SpouseMedicarePartB', this.spouseMedicareCoverageForm.value.SpouseMedicarePartB)
        spousePremiums = {
          "SpouseMedicarePartB": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.MedicarePartB : this.spouseMedicareCoverageForm.value.SpouseMedicarePartB || false,
          "SpouseMedicarePartD": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.MedicarePartD : this.spouseMedicareCoverageForm.value.SpouseMedicarePartD || false,
          "SpouseSupplimentalInsurance": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.SupplimentalInsurance : this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance || false,
          "SpouseDentalInsurance": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.DentalInsurance : this.spouseMedicareCoverageForm.value.SpouseDentalInsurance || false
        } 
      } else if(this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO'){
        spousePremiums = {
          "SpouseMedicareAdvantageHMO": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.MedicareAdvantageHMO : this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO || false,
          "SpouseDentalInsurance": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.DentalInsurance : this.spouseMedicareCoverageForm.value.SpouseDentalInsurance || false
        }
      } else if(this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO'){
        spousePremiums = { 
          "SpouseMedicareAdvantagePPO": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.MedicareAdvantagePPO : this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO || false,
          "SpouseDentalInsurance": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.DentalInsurance : this.spouseMedicareCoverageForm.value.SpouseDentalInsurance || false
        }
      }

      spouseOOPCosts = {
        "SpouseHospitalAndTest": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.HospitalAndTest : this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest,
        "SpousePrescriptionDrugs": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.PrescriptionDrugs : this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs,
        "SpouseHearingAndVisionCosts": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.HearingAndVisionCosts : this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts,
        "SpouseDentalCosts": (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.DentalCosts : this.spouseMedicareCoverageForm.value.SpouseDentalCosts
      }
    }


    let yearNow = new Date().getFullYear();
    let isOptionEnter = (this.incomeEntryForm.value.HouseHoldIncome && this.incomeEntryForm.value.IncomeInflationRate && this.incomeEntryForm.value.IncomeReplacementRatio) ? true : false;
    
    let currentIncome = isOptionEnter && this.incomeEntryForm.value.HouseHoldIncome ? Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome) 
      : (this.incomeRangeSelectionForm.value.BracketValue || this.incomeEntryForm.value.YearOneRetirementIncome  ? null : this.client.clientProfile.CurrentIncome);
    
    let iRR = isOptionEnter && this.incomeEntryForm.value.IncomeReplacementRatio ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio): (this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.IRR);
    let inflationRate = isOptionEnter && this.incomeEntryForm.value.IncomeInflationRate ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate): (this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.InflationRate);
    var inRetirementInflationRate = isOptionEnter && this.additinalIncomeForm.value.InRetInflationRate != null ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.InRetInflationRate): (this.incomeRangeSelectionForm.value.BracketValue ? null : (this.additinalIncomeForm.value.InRetInflationRate != null) ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.InRetInflationRate) : this.client.clientProfile.InRetirementInflationRate);
    console.log('this.incomeEntryForm.value.HouseHoldIncome', this.incomeEntryForm.value.HouseHoldIncome);
    console.log('this.incomeEntryForm.value.IncomeInflationRate', this.incomeEntryForm.value.IncomeInflationRate)
    console.log('this.incomeEntryForm.value.IncomeReplacementRatio', this.incomeEntryForm.value.IncomeReplacementRatio);
    console.log('this.isOptionEnter', isOptionEnter);



    let yearOneRetirementIncome = this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.removeCurrencyFormatting(this.incomeEntryForm.value.YearOneRetirementIncome) : (this.incomeRangeSelectionForm.value.BracketValue || this.incomeEntryForm.value.HouseHoldIncome  ? null : this.client.clientProfile.HouseholdYearOneIncome);
    console.log('isHouseholdIncomeDivide', this.isHouseholdIncomeDivide)
    if(isOptionEnter && this.incomeEntryForm.value.HouseHoldIncome) {
      console.log('here i am');
      if (this.isHouseholdIncomeDivide) {
        let dividedHouseholdIncome = Math.round(currentIncome/2);
        this.client.clientProfile.Spouses[0].currentIncome =dividedHouseholdIncome;
        currentIncome = dividedHouseholdIncome;
      } else {
        if (this.isMarried) {
          console.log('this.incomeEntryForm.value.HouseHoldIncome', this.incomeEntryForm.value.HouseHoldIncome);
          console.log('this.client.clientProfile.Spouses[0].currentIncome', this.client.clientProfile.Spouses[0].currentIncome)
          currentIncome = Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome) - ((this.client.clientProfile.Spouses[0].currentIncome) ? this.client.clientProfile.Spouses[0].currentIncome : 0);
        }

      }

    }

    if (currentIncome != this.client.clientProfile.CurrentIncome) {
      this.incomeRangeSelectionForm.controls['BracketValue'].patchValue(null);
    }
    console.log('her ei am 01');
    if (this.isPre65 && this.isSpousePre65 && this.isSpouseSameHCSelection) {
      console.log('her ei am 02');
      this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].setValue(this.healthInsuranceForm.value.IsPrivateHealthInsurance);
      this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].setValue(this.healthInsuranceForm.value.CoverageType);
    }
    console.log('this.isIncomeSelectionCard', this.isIncomeSelectionCard );
    console.log('yearOneRetirementIncome', yearOneRetirementIncome);
    console.log('this.healthInsuranceForm.value.CoverageType', this.healthInsuranceForm.value.CoverageType );
    console.log('this.isIncomeSelectionCard', this.isIncomeSelectionCard)
    let isPrivateHealthInsurance = this.healthInsuranceForm.value.IsPrivateHealthInsurance ? (this.healthInsuranceForm.value.IsPrivateHealthInsurance == 'true'? true: false):this.client.clientProfile.IsPrivHealthIns;
    isPrivateHealthInsurance = this.isPre65 ? isPrivateHealthInsurance: false;
    let isSpousePrivateHealthInsurance = this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance ? (this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance == 'true'? true: false): this.client.clientProfile.IsSpousePrivHealthIns;
    isSpousePrivateHealthInsurance = this.isSpousePre65 ? isSpousePrivateHealthInsurance: false;
    console.log('isSpousePrivateHealthInsurance', isSpousePrivateHealthInsurance)
    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      // CurrentIncome: this.isIncomeSelectionCard == 1 && (this.isAdditionalQuestion || this.isIncomeSelection || this.isAdditionalIncome)? currentIncome: this.client.clientProfile.CurrentIncome,
      CurrentIncome: this.isIncomeSelectionCard == 1 && (this.isAdditionalQuestion || this.isIncomeSelection || this.isAdditionalIncome)? currentIncome: (this.isIncomeSelectionCard == 2 ? null: this.client.clientProfile.CurrentIncome),
      IRR: iRR,
      InflationRate: inflationRate,
      RetirementAge: this.client.clientProfile.RetirementAge,
      Pension: this.client.clientProfile.Pension,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,
      
      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

      HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag || 0,
      HCCYrsDiag: this.client.clientProfile.HCCYrsDiag || 0,
      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
      PensionMonths: this.client.clientProfile.PensionMonths,
      PensionYears: this.client.clientProfile.PensionYears,
      SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,
      IncludePension: this.client.clientProfile.IncludePension,
      PIA: this.client.clientProfile.PIA,
      PIAYears: (!this.client.clientProfile.PIAYears || this.client.clientProfile.PIAYears == 'null') ? null : JSON.stringify(this.client.clientProfile.PIAYears),
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
      IsPrivHealthIns: isPrivateHealthInsurance,
      CoverageType: isPrivateHealthInsurance ? (this.healthInsuranceForm.value.CoverageType ? this.healthInsuranceForm.value.CoverageType: this.client.clientProfile.CoverageType): null,

      PremiumType: this.medicareCoverageForm.value.HealthCarePremiumType ? this.medicareCoverageForm.value.HealthCarePremiumType: this.client.clientProfile.PremiumType,
      Premiums:  this.medicareCoverageForm.value.HealthCarePremiumType ? JSON.stringify(premiums): JSON.stringify(JSON.parse(this.client.clientProfile.Premiums)),
      
      IsHSApplySpouse: this.medicareCoverageForm.value.IsSpouseSameHCSelection != null ? this.medicareCoverageForm.value.IsSpouseSameHCSelection: this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: isSpousePrivateHealthInsurance,
      SpouseCoverageType: isSpousePrivateHealthInsurance ? (this.spouseHealthInsuranceForm.value.SpouseCoverageType ? this.spouseHealthInsuranceForm.value.SpouseCoverageType: this.client.clientProfile.SpouseCoverageType): null,
      
      SpousePremiumType: this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType ? this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType : this.client.clientProfile.SpousePremiumType,
      SpousePremiums: this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType ? JSON.stringify(spousePremiums): this.client.clientProfile.SpousePremiums,
      
      // Bracket: this.incomeRangeSelectionForm.value.BracketValue && this.isIncomeSelectionCard == 2 ? this.incomeRangeSelectionForm.value.BracketValue : null,
      Bracket: this.incomeRangeSelectionForm.value.BracketValue && this.isIncomeSelectionCard == 2 && (this.isAdditionalQuestion || this.isIncomeRangeSelection) ? this.incomeRangeSelectionForm.value.BracketValue : this.client.clientProfile.Bracket,
      // HouseholdYearOneIncome: this.isIncomeSelectionCard == 1 ?  yearOneRetirementIncome: null,
      HouseholdYearOneIncome: this.isIncomeSelectionCard == 1 && (this.isAdditionalQuestion || this.isIncomeSelection || this.isAdditionalIncome)? yearOneRetirementIncome: (!this.isAdditionalQuestion ? this.client.clientProfile.HouseholdYearOneIncome :null),
      HouseholdYearOneIncomeChangeYear: null,
      InRetirementInflationRate: inRetirementInflationRate,
      MAGIPercentIncome: (isOptionEnter || (!this.incomeEntryForm.value.HouseHoldIncome && yearOneRetirementIncome)) && this.additinalIncomeForm.value.MAGIPerc ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.MAGIPerc): null,
      OOPCosts: this.medicareCoverageForm.value.HealthCarePremiumType ? JSON.stringify(oopCosts): JSON.stringify(JSON.parse(this.client.clientProfile.OOPCosts)),
      SpouseOOPCosts: this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType ? JSON.stringify(spouseOOPCosts): JSON.stringify(JSON.parse(this.client.clientProfile.SpouseOOPCosts)),
      ClientMetroArea: this.client.clientProfile.ClientMetroArea,
      SpouseMetroArea: this.client.clientProfile.SpouseMetroArea,
      YearOfStatement: this.client.clientProfile.YearOfStatement,

      //TODO: set up for different plans for different clients
      SelfSupplementalPlan: this.medicareCoverageForm.value.SupplementalPlan,//(this.client.clientProfile.SelfSupplementalPlan) ? this.client.clientProfile.SelfSupplementalPlan : "G",
      SpouseSupplementalPlan: (this.client.clientProfile.IsHSApplySpouse) ? this.medicareCoverageForm.value.SupplementalPlan : this.spouseMedicareCoverageForm.value.SpouseSupplementalPlan//(this.client.clientProfile.SpouseSupplementalPlan) ? this.client.clientProfile.SpouseSupplementalPlan : "G"
     }

    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }
    var RiskTolerance = null;

    var AdditionalQuestion = null;

    if (this.params == '' || this.params == 'emptyAll' || this.params == 'empty' || this.isEditAll || this.params == "additionalQuestions") {
      AdditionalQuestion = {
        Firm: this.additionalQuestionsForm.value.Firm,
        PlanSponsor: this.additionalQuestionsForm.value.PlanSponsor,
        Wholesaler: this.additionalQuestionsForm.value.Wholesaler,
        SendReportTo: this.additionalQuestionsForm.value.SendReportTo,
        RepName: this.additionalQuestionsForm.value.RepName,
        MeetingReference: this.additionalQuestionsForm.value.MeetingReference,
        ReportRequestFrom: this.additionalQuestionsForm.value.ReportRequestFrom,
        FromHCLTCComb: 'HC'
      }
    }

  var MidRetirementAdj = null;
  if (this.params == 'income' || this.params == '' || this.isEditAll) {
    MidRetirementAdj = {
      Year: this.additinalIncomeForm.value.RetAdjYear || null,
      ReductionDollar: this.additinalIncomeForm.value.RetAdjReductionDollar != null ? Utils.removeCurrencyFormatting(this.additinalIncomeForm.value.RetAdjReductionDollar) : null,
      ReductionPerc: this.additinalIncomeForm.value.RetAdjReductionPerc != null ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.RetAdjReductionPerc) : null,
      IncomeInflationRate: this.additinalIncomeForm.value.RetAdjReductionInflation != null ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.RetAdjReductionInflation) : null
    }
  }

    var modalData;
    let LstMAGIProj = [];
    if (this.isMAGIUpdate) {
      for(var data of this.mmtModalData) {
        modalData = {
          Year: Number(data.year),
          Age: data.age,
          // Income: Number(data.fullMAGI.toString().includes('$')? Utils.removeCurrencyFormatting(data.fullMAGI): data.fullMAGI),
          Income: Number(Utils.removeCurrencyFormatting(data.fullMAGI.toString())),
          MAGI: Number(Utils.removeCurrencyFormatting(data.percentMAGI.toString())),
          Bracket: Number(data.updatedBracket)
        }
        LstMAGIProj.push(modalData);
      }

    }
    console.log('this.additionalQuestionsForm', this.additionalQuestionsForm);
    console.log('this.isOptionEnter', this.isOptionEnter);
    console.log(' this.incomeEntryForm.value.HouseHoldIncome',  this.incomeEntryForm.value.HouseHoldIncome);
    console.log('ClientProfile', ClientProfile);
    console.log('this.medicareCoverageForm.value.IsSpouseSameHCSelection', this.medicareCoverageForm.value.IsSpouseSameHCSelection)
    console.log('MidRetirementAdj', MidRetirementAdj);
    console.log('this.mmtModalData', this.mmtModalData);
    console.log('LstMAGIProj', LstMAGIProj);
    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj)
    .subscribe(
      resp => {
        // if (this.isEnableUpdateButton || this.isEditAll) {
          this.router.navigate(['/clients/edit']);
        // }
      },
      error => {

      });
  }

  previous(scenario) {
    this.resetFormBooleanValue();
    if (scenario == 'healthInsuranceForm') {
      this.router.navigate(['/clients/edit'])
    }
    if (scenario == 'medicareCoverageForm') {
      this.isHealthInsurance = true;
    }
    if (scenario == 'spouseHealthInsuranceForm') {
      if(this.params == "pre65"){
        this.isHealthInsurance = true;
      } else {
        this.isMedicareCoverage = true;
      }
    }
    if (scenario == 'spouseMedicareCoverageForm') {
      if (this.isEnableUpdateButton && this.isShowSpouse && !this.isSpouseSameHCSelection) {
        this.isMedicareCoverage = true;
      } else {
        // this.isSpouseHealthInsurance = true;
        this.isSpouseHealthInsurance = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false: true): true;
        this.isMedicareCoverage = !this.isSpouseHealthInsurance ? true : this.isMedicareCoverage;
      }

    }
    if (scenario == 'incomeSelectionForm') {
      if (this.isMarried && !this.isSpouseSameHCSelection) {
        this.isSpouseMedicareCoverage = true;
        // if (this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance == 'true') {
        //   this.isSpouseMedicareCoverage = true;
        // } else {
        //   // this.isSpouseHealthInsurance = true;
        //   this.isSpouseHealthInsurance = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.client.Spouses[0].dob)) >= 65) ? false: true): true;
        //   this.isSpouseMedicareCoverage = !this.isSpouseHealthInsurance ? true : this.isSpouseMedicareCoverage;
        // }
      } else {
        if (this.isMarried && !this.isPre65 && this.isSpousePre65) {
          this.isMedicareCoverage = false;
          this.isSpouseHealthInsurance = true;
        } else {
          this.isMedicareCoverage = true;
        }
        
        // if (this.healthInsuranceForm.value.IsPrivateHealthInsurance == 'true') {
        //   this.isMedicareCoverage = true;
        // } else {
        //   this.isHealthInsurance = true;
        // }
      }
    }
    if (scenario == 'incomeRangeSelectionForm') {
      this.isIncomeSelection = true;
    }
    if (scenario == 'incomeEntryForm') {
      if (this.params == 'income') {
        this.isIncomeSelection = true;

      } else {
      // this.isIncomeSelection = true;
      if (this.isSSFilledBefore && !this.client.clientProfile.Bracket) {
        if (this.isMarried && !this.isSpouseSameHCSelection) {
          this.isSpouseMedicareCoverage = true;
        } else {
          this.isMedicareCoverage = true;
        }
      } else {
        this.isIncomeSelection = true;
      }
      }

    }
    if (scenario == 'additionalQuestionsForm') {
      if (this.isOptionEnter) {
        this.isAdditionalIncome = true;
        // this.isMAGIProjection = true;
      } else {
        this.isIncomeRangeSelection = true;

      }

    }
    if (scenario == 'additinalIncomeForm') {
      this.isIncomeEnter = true;
    }
    if (scenario == 'magiProjectionForm') {
      this.isAdditionalIncome = true;
    }

  }

  resetFormBooleanValue() {
    this.isHealthInsurance = this.isMedicareCoverage = this.isAdditionalQuestion = this.isIncomeSelection = 
    this.isIncomeEnter = this.isIncomeRangeSelection = this.isMAGIProjection = this.isAdditionalIncome = this.isSpouseHealthInsurance 
    = this.isSpouseMedicareCoverage = false;
  }

  changeSelection(isShowSpouse) {
    console.log('changeSelection', isShowSpouse);
    this.isTraditinalPremium = this.isHMOMedicareAdvantage =  this.isPPOMedicareAdvantage = false;

    if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM') {
      this.isTraditinalPremium = true;
      //this.medicareCoverageForm.controls['MedicarePartB'].setValue(true);
      //this.medicareCoverageForm.controls['MedicarePartD'].setValue(true);
    }
    if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO') {
      this.isHMOMedicareAdvantage = true;
      this.medicareCoverageForm.controls['MedicareAdvantageHMO'].setValue(true);
    }
    if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO') {
      this.isPPOMedicareAdvantage = true;
      this.medicareCoverageForm.controls['MedicareAdvantagePPO'].setValue(true);
    }

    this.onCheckBoxChange('client');

    if (isShowSpouse) {
      this.isSpouseTraditinalPremium = this.isSpouseHMOMedicareAdvantage =  this.isSpousePPOMedicareAdvantage = false;
      console.log('this.spouseMedicareCoverageForm', this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType)
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM') {
        this.isSpouseTraditinalPremium = true;
        //this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].setValue(true);
        //this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].setValue(true);
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO') {
        this.isSpouseHMOMedicareAdvantage = true;
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].setValue(true);
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO') {
        this.isSpousePPOMedicareAdvantage = true;
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].setValue(true);
      }

      this.onCheckBoxChange('spouse');
    }
  }

  update() {
    this.updateClientProfileWithHCQuestionnaire();
  }

  cancel() {
    this.router.navigate(['/clients/edit']);
  }

  selectOptions(scenario, selectAll = false) {
    console.log('scenario', scenario);
    if (scenario == 'currentIncome') {

      this.isOptionCurrentIncome = true;
      // this.incomeEntryForm.get("HouseHoldIncome").setValidators([Validators.required]);
      // this.incomeEntryForm.get("IncomeInflationRate").setValidators([Validators.required]);
      // this.incomeEntryForm.get("IncomeReplacementRatio").setValidators([Validators.required]);
      
      // this.incomeEntryForm.get("HouseHoldIncome").updateValueAndValidity();
      // this.incomeEntryForm.get("IncomeInflationRate").updateValueAndValidity();
      // this.incomeEntryForm.get("IncomeReplacementRatio").updateValueAndValidity();
      this.incomeEntryForm.get("YearOneRetirementIncome").reset();
      this.incomeEntryForm.get("YearOneRetirementIncome").clearValidators();
      this.incomeEntryForm.get("YearOneRetirementIncome").updateValueAndValidity();

    } else if (scenario == 'selectAllOOPCosts') {
      this.enableControls('client');
      if (((this.isTraditinalPremium && (this.medicareCoverageForm.value.MedicarePartB || this.medicareCoverageForm.value.MedicarePartD || this.medicareCoverageForm.value.SupplimentalInsurance || this.medicareCoverageForm.value.DentalInsurance)) || this.isHMOMedicareAdvantage || this.isPPOMedicareAdvantage) || selectAll) {
        this.medicareCoverageForm.controls['HospitalAndTest'].setValue(selectAll);
        this.medicareCoverageForm.controls['PrescriptionDrugs'].setValue(selectAll);
        this.medicareCoverageForm.controls['HearingAndVisionCosts'].setValue(selectAll);
        this.medicareCoverageForm.controls['DentalCosts'].setValue(selectAll);
      }


    } else if (scenario == 'selectAllSpouseOOPCosts') {
      this.enableControls('spouse');
      console.log('selectAll', selectAll)
      if (((this.isSpouseTraditinalPremium && (this.spouseMedicareCoverageForm.value.SpouseMedicarePartB || this.spouseMedicareCoverageForm.value.SpouseMedicarePartD || this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance || this.spouseMedicareCoverageForm.value.SpouseDentalInsurance)) || this.isSpouseHMOMedicareAdvantage || this.isSpousePPOMedicareAdvantage) || selectAll) {
        this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].setValue(selectAll);
        this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].setValue(selectAll);
        this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].setValue(selectAll);
        this.spouseMedicareCoverageForm.controls['SpouseDentalCosts'].setValue(selectAll);
      }


    }else if (scenario == 'selectAllOOPPremiums') {
      this.enableControls('client');
      if ((this.medicareCoverageForm.value.HospitalAndTest || this.medicareCoverageForm.value.PrescriptionDrugs || this.medicareCoverageForm.value.HearingAndVisionCosts || this.medicareCoverageForm.value.DentalCosts) || selectAll){
        if(this.isTraditinalPremium){
          if(this.medicareCoverageForm.controls['SupplimentalInsurance'].disabled){
            this.medicareCoverageForm.controls['SupplimentalInsurance'].enable();
          }
          this.medicareCoverageForm.controls['MedicarePartB'].setValue(true);
          this.medicareCoverageForm.controls['MedicarePartD'].setValue(true);
          this.medicareCoverageForm.controls['SupplimentalInsurance'].setValue(selectAll);        
        } else if(this.isHMOMedicareAdvantage){
          this.medicareCoverageForm.controls['MedicareAdvantageHMO'].setValue(true);
        } else if(this.isPPOMedicareAdvantage){
          this.medicareCoverageForm.controls['MedicareAdvantagePPO'].setValue(true);
        }
        
        this.medicareCoverageForm.controls['DentalInsurance'].setValue(selectAll);
      }


    } else if (scenario == 'selectAllSpouseOOPPremiums') {
      this.enableControls('spouse');
      console.log('selectAllSpouseOOPPremiums')
      if ((this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest || this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs || this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts || this.spouseMedicareCoverageForm.value.SpouseDentalCosts) || selectAll) {
        if(this.isSpouseTraditinalPremium){
          if(this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].disabled){
            this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].enable();
          }
          this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].setValue(true);
          this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].setValue(true);
          this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].setValue(selectAll);
        } else if(this.isSpouseHMOMedicareAdvantage){
          console.log('this.isSpouseHMOMedicareAdvantage', selectAll)
          this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].setValue(true);
        } else if(this.isSpousePPOMedicareAdvantage){
          this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].setValue(true);
        }      
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].setValue(selectAll);
      }


    } else if (scenario == 'spouseSameHealthCareSelection') {

      this.isSpouseSameHCSelection = !this.isSpouseSameHCSelection ;
      this.medicareCoverageForm.controls['IsSpouseSameHCSelection'].setValue(this.isSpouseSameHCSelection);
      
      if (this.isSpouseSameHCSelection) {
        // check if spouse is pre65?
        if (this.isSpousePre65 && this.isPre65) {
          this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].setValue(this.healthInsuranceForm.value.IsPrivateHealthInsurance);
        }
        
        this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].setValue(this.healthInsuranceForm.value.CoverageType);

        this.spouseMedicareCoverageForm.controls['SpouseHealthCarePremiumType'].setValue(this.medicareCoverageForm.value.SpouseHealthCarePremiumType);
        this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].setValue(this.medicareCoverageForm.value.MedicarePartB);
        this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].setValue(this.medicareCoverageForm.value.MedicarePartD);
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].setValue(this.medicareCoverageForm.value.SupplimentalInsurance);
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].setValue(this.medicareCoverageForm.value.MedicareAdvantagePPO);
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].setValue(this.medicareCoverageForm.value.DentalInsurance);
        this.spouseMedicareCoverageForm.controls['SpouseSupplementalPlan'].setValue(this.medicareCoverageForm.value.SpouseSupplementalPlan);

        if(this.params == 'medCoverage'){
          this.isEnableUpdateButton = true;
        }

      } else {
        
        this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].reset();
        this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].reset();
        this.spouseMedicareCoverageForm.controls['SpouseHealthCarePremiumType'].reset();
        this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].reset();
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].reset();
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].reset();
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].reset();

        if(this.params == 'medCoverage'){
          this.isEnableUpdateButton = false;
        }
      }

    } else {


      this.isOptionCurrentIncome = false;
      this.incomeEntryForm.get("YearOneRetirementIncome").setValidators([Validators.required]);

      this.incomeEntryForm.get("YearOneRetirementIncome").updateValueAndValidity();

      //reset the IIR and IRR if empty to defaulted values from form
      if(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.get('IncomeInflationRate').errors){
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue('3.00%');
      }

      if(!this.incomeEntryForm.value.IncomeReplacementRatio || this.incomeEntryForm.get('IncomeReplacementRatio').errors){
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue('75%');
      }

      //set the year one value with new set values above
      //household income at yr 1 of retirement = current income * (1 + income inflation rate) ^ (retirement year - current year + 1) * IRR
      let houseHoldIncome = Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome);
      let incomeInflationRate = Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate);
      console.log('household', houseHoldIncome, incomeInflationRate)

      let firstRetireeYears = Math.max(0, (new Date(this.client.client.DOB).getFullYear() + this.client.clientProfile.RetirementAge) - new Date().getFullYear());
      if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
        firstRetireeYears = Math.min((new Date(this.client.clientProfile.Spouses[0].dob).getFullYear() + this.client.clientProfile.Spouses[0].retirementAge) - new Date().getFullYear())
      
      if (houseHoldIncome > 0 && incomeInflationRate > 0) {
        this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(
          Utils.formatToCurrency(Math.round(Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome) * Math.pow(1 + (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) / 100), Math.max(0, firstRetireeYears - 1)) * (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) / 100)))
        );
      } else {
        console.log('here i am YearOneRetirementIncome')
        this.incomeEntryForm.get("YearOneRetirementIncome").reset();
      }
      //this.incomeEntryForm.get("HouseHoldIncome").reset();
      //this.incomeEntryForm.get("IncomeInflationRate").reset();
      //this.incomeEntryForm.get("IncomeReplacementRatio").reset();

      //this.incomeEntryForm.get("HouseHoldIncome").clearValidators();
      //this.incomeEntryForm.get("IncomeInflationRate").clearValidators();
      //this.incomeEntryForm.get("IncomeReplacementRatio").clearValidators();

      // this.incomeEntryForm.get("HouseHoldIncome").updateValueAndValidity();
      this.incomeEntryForm.get("IncomeInflationRate").updateValueAndValidity();
      this.incomeEntryForm.get("IncomeReplacementRatio").updateValueAndValidity();
    }
    if (scenario == 'selectAllOOPPremiums' || scenario == 'selectAllOOPCosts') {
      this.onCheckBoxChange('client')
    }
    if (scenario == 'selectAllSpouseOOPPremiums' || scenario == 'selectAllSpouseOOPCosts') {
      this.onCheckBoxChange('spouse')
    }

  }
  
  // manualYearOneRetIncomeEntry(amount) {
  //   console.log('here i am')
  //   amount = amount.replace(/\D/g, '');
  //   // this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.removeCurrencyFormatting(this.incomeEntryForm.value.YearOneRetirementIncome));
  //   this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Math.round(Utils.removeCurrencyFormatting(amount) / Math.pow((1 + (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) / 100)), Math.max(0, ((this.client.clientProfile.RetirementAge - this.globalService.calculateAge(this.client.client.DOB) + new Date().getFullYear()) - (new Date().getFullYear() + 1)))) / (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) / 100))));
  //   this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(amount));
  //   // this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(val));
  //   // return val;
  // }

  enableDisablePercMAGI() {
    this.isEditPercentMAGI = !this.isEditPercentMAGI;
  }

  getClient() {
    this.isEditPercentMAGI = false;
    if (this.params == '') {
      this.selectOptions('currentIncome');
    }
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
        .subscribe(
            client => {
                this.client = client;
                this.isSSFilledBefore = this.client.clientProfile.MonthlyBenefitAmount || this.client.clientProfile.PIA || this.client.clientProfile.SelfKnownBenefitClaiming ? true : false;
                if (this.client.clientProfile.Spouses) {
                  this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
                }
                console.log('this.client',this.client);
                console.log('this.parmas', this.params);
                this.isMarried =  client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
                this.isPre65 = (Number(this.client.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false: true;
                this.isSpousePre65 = ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false: true);
                console.log('client.clientProfile.Spouses[0].retirementAge', this.client.clientProfile.Spouses[0].retirementAge)
                console.log('this.isSpousePre65', this.isSpousePre65)
                this.isHealthInsurance = !this.isPre65 ? false: this.isHealthInsurance;
                
                this.isMedicareCoverage = !this.isPre65 && this.params != 'income' && this.params != 'pre65' && this.params != 'additionalQuestions' ? true: this.isMedicareCoverage;

                this.isSpouseHealthInsurance = this.isSpousePre65 && !this.isHealthInsurance && this.isMarried && this.params == 'pre65' ? true: this.isSpouseHealthInsurance;

                this.isSpouseHealthInsurance = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false: this.isSpouseHealthInsurance): this.isSpouseHealthInsurance;
                this.client.clientProfile.Spouses[0].maritalStatus == 'Married'
                this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ?
                (client.client.LastName == client.clientProfile.Spouses[0].lastName) ? 
                      client.client.FirstName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.client.LastName :
                      client.client.FirstName + ' ' + client.client.LastName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName
                      : client.client.FirstName + ' ' + client.client.LastName;

                                
                this.clientFirstName = client.client.FirstName;

                this.isClientInExemptState = (client.clientProfile.RetirementState == 'MA' || client.clientProfile.RetirementState == 'MN' || client.clientProfile.RetirementState == 'WI');
                              
                //let isSpouse = this.client.clientProfile.Spouses[0] ? true : false;
                this.isSpouse = this.isMarried;

                //this.enableControls('client');
                if (this.isMarried) {
                  this.isLegalMarried = (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].isLegalSpouse == 1 &&  this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? true: false;                  
                  this.couplePassesAwaySameYear = (this.isLegalMarried) && (((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) + new Date().getFullYear()) == ((this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB) + new Date().getFullYear()))) ? true : false;

                  this.spouseFirstName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].firstName ? client.clientProfile.Spouses[0].firstName: 'Spouse'; 
                  this.isSpouseInExemptState = (client.clientProfile.Spouses[0].state == 'MA' || client.clientProfile.Spouses[0].state == 'MN' || client.clientProfile.Spouses[0].state == 'WI');

                  //this.enableControls('spouse');
                }
                this.isSocialSecurityEdit = this.client.clientProfile.CurrentIncome >= 0 && (this.client.clientProfile.SelfKnownBenefitClaiming || this.client.clientProfile.PIA || this.client.clientProfile.SelfKnownBenefitClaiming == 0 || this.client.clientProfile.PIA == 0 || this.client.clientProfile.Pension || this.client.clientProfile.InRetFirstYearIncome || this.client.clientProfile.MonthlyBenefitAmount || this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.Spouses.length > 1) ? true : false;
                this.previousEnteredHousholdIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0); 
                //this.changeSelection(this.isMarried);

                this.getMMTBracket();
            },
            error => console.log(error));
  }

  getMMTBracket() {
    let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    // let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
    // let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)): null;
    // let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
    let bracketYear = currentYear;
    

    this.client.clientProfile.HCCDYrsDiag = this.client.clientProfile.HCCDYrsDiag || 0;
    this.client.clientProfile.HCCYrsDiag = this.client.clientProfile.HCCYrsDiag || 0;
    if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      this.client.clientProfile.Spouses[0].HCCDYrsDiag =  this.client.clientProfile.Spouses[0].HCCDYrsDiag || 0;
      this.client.clientProfile.Spouses[0].HCCYrsDiag = this.client.clientProfile.Spouses[0].HCCYrsDiag || 0;
    }
    console.log('bracketYear', bracketYear);
    this.globalService.getMMTBracket(includePartner, bracketYear)
            .subscribe(
                data => {
                  console.log('data', data);
                  this.magiBracketOneMin = data.Bracket1 ? data.Bracket1: 0;
                  this.magiBracketOneMax = data.Bracket2 ? data.Bracket2 - 1 : 0;

                  this.magiBracketTwoMin = data.Bracket2 ? data.Bracket2 : 0;
                  this.magiBracketTwoMax = data.Bracket3 ? data.Bracket3 - 1 : 0;

                  this.magiBracketThreeMin = data.Bracket3 ? data.Bracket3 : 0;
                  this.magiBracketThreeMax = data.Bracket4 ? data.Bracket4 - 1 : 0;

                  this.magiBracketFourMin = data.Bracket4 ? data.Bracket4 : 0;
                  this.magiBracketFourMax = data.Bracket5 ? data.Bracket5 - 1 : 0;

                  this.magiBracketFiveMin = data.Bracket5 ? data.Bracket5 : 0;
                  this.magiBracketFiveMax = data.Bracket6 ? data.Bracket6 - 1 : 0;

                  this.magiBracketSixMin = data.Bracket6 ? data.Bracket6 : 0;
                  this.magiBracketSixMax= 'more';
                  this.insertDataToHCQuestionnaire();

                  this.getMMTData();

                  // if (this.params == 'income') {
                  //   let magiProjs =  JSON.parse(this.client.magiProjs) || [];
                  //   magiProjs = magiProjs.sort((a,b)=> a.Year - b.Year);
                  //   this.mmtModalData = magiProjs.map((entry, idx) => {
                  //     let updatedEntry = {
                  //         year: entry.Year,
                  //         age: entry.Age,
                  //         fullMAGI: entry.Income,
                  //         percentMAGI: entry.MAGI,
                  //         updatedBracket:  entry.Bracket
                  //     }

                  //     return updatedEntry;
                   
                  //   });
                  //   console.log('this.mmtModalData', this.mmtModalData);
                  //   this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
                  //   console.log('test',this.mmtModalData.find(x => x.year == '2068').percentMAGI);
                  //   this.populateForm();
      

                  // } else {
                  //   this.getMMTData();


                  // }
 
 
                },
                error => console.log(error));
  }

  getMMTData() {
    if (this.params == 'income' || this.isEditAll) {
      let magiProjs =  JSON.parse(this.client.magiProjs) || [];
      var mapMMTModalData = [];
      magiProjs = magiProjs.sort((a,b)=> a.Year - b.Year);
      mapMMTModalData = magiProjs.map((entry, idx) => {
        let updatedEntry = {
            year: entry.Year,
            age: entry.Age,
            fullMAGI: entry.Income,
            percentMAGI: entry.MAGI,
            updatedBracket:  entry.Bracket
        }
  
        return updatedEntry;
     
      });
      console.log('mapMMTModalData', mapMMTModalData);
    }

        
    var tempReportVals = {
        InflationRate: 0.03,
        MagiIncomePercent: 100,
        IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
        SocialSecurityRetirementAge: this.ssClientAge,
        SSMonthlyBenefit: this.client.clientProfile.PIA,
        PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
        PartnerSocialSecurityAge: this.ssSpouseAge
    }

    var user = {
        UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
        CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
        ClientID: localStorage.getItem('selectedClient')
    }
    console.log('here01 i am mmtData');
    this.globalService.getMMTData(this.client, tempReportVals, user)
        .subscribe(
            data => {
              // console.log('here02 i am mmtData');
              // console.log('data', data);

              this.startingIllustration = data.IllustrationEntries;

              this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                      // this.mmtData = data;

                      entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                      if (entry.PartnerAge)
                          entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;
                      // console.log('year', entry.Year);
                      let fullMAGI;
                      let percentMAGI = entry.MagiAdjustedHouseholdIncome;
                      let updatedBracket;
                      if ((this.params == 'income' || this.isEditAll) && mapMMTModalData.length > 0) {
                        fullMAGI = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).fullMAGI : entry.HouseholdIncome;
                        percentMAGI = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).percentMAGI : entry.MagiAdjustedHouseholdIncome;
                        updatedBracket = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).updatedBracket.toLocaleString() : entry.MagiAdjustedIncomeBracket.toLocaleString();
                      } else {
                        fullMAGI = entry.HouseholdIncome;
                        percentMAGI = entry.MagiAdjustedHouseholdIncome;
                        updatedBracket = entry.MagiAdjustedIncomeBracket.toLocaleString();
                      }
                      let updatedEntry = {
                          year: entry.PartnerAge ? `${entry.Year}` : `${entry.Year}`,
                          age: entry.PartnerAge ? `${entry.ClientAge}/${entry.PartnerAge}` : `${entry.ClientAge}`,
                          magi: this.magi.toLocaleString(),
                          fullMAGI: this.formatCurrency(fullMAGI, ''),
                          percentMAGI: this.formatCurrency(percentMAGI, ''), // this.formatCurrency(entry.MagiAdjustedHouseholdIncome, ''),
                          updatedBracket:  updatedBracket,
                          premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0], ''),
                          surcharges: this.formatCurrency((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]), ''),
                          total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                          savings: this.formatCurrency((Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0])))), '')
                      }
                      // console.log('updateEntry', updatedEntry);
                      updatedEntry.total = this.formatCurrency(updatedEntry.total, '');
                      return updatedEntry;
                  }
              });

              this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
              this.populateForm();


            },
            error => console.log(error));
  }

  insertDataToHCQuestionnaire() {
    this.isShowSpouse = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
    if (this.params == 'pre65' || this.isEditAll) {
      // let isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
      this.healthInsuranceForm.controls['IsPrivateHealthInsurance'].setValue(this.client.clientProfile.IsPrivHealthIns ? 'true': 'false');
      if (this.client.clientProfile.IsPrivHealthIns) {
        this.healthInsuranceForm.controls['CoverageType'].setValue (this.client.clientProfile.CoverageType);
      }
      this.medicareCoverageForm.controls['IsSpouseSameHCSelection'].setValue(this.client.clientProfile.IsHSApplySpouse);
      // this.isShowSpouse = this.isEditAll ? (isMarried == 'true' ? true :false) :((isMarried == 'true')  && (this.client.clientProfile.IsPrivHealthIns != this.client.clientProfile.IsSpousePrivHealthIns|| this.client.clientProfile.CoverageType != this.client.clientProfile.SpouseCoverageType)? true: false);
      if (this.isShowSpouse) {
        this.spouseHealthInsuranceForm.controls['IsSpousePrivateHealthInsurance'].setValue (this.client.clientProfile.IsSpousePrivHealthIns ? 'true': 'false');
        if (this.client.clientProfile.IsSpousePrivHealthIns) {
          this.spouseHealthInsuranceForm.controls['SpouseCoverageType'].setValue (this.client.clientProfile.SpouseCoverageType);
        }
        this.isSpouseSameHCSelection = this.client.clientProfile.IsHSApplySpouse;
      }
    }
    if (this.params == 'medCoverage' || this.isEditAll) {
      // let isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
      this.medicareCoverageForm.controls['HealthCarePremiumType'].setValue ((this.client.clientProfile.PremiumType) ? this.client.clientProfile.PremiumType : "");
      this.changeSelection(this.isShowSpouse);
      var premiums = JSON.parse(this.client.clientProfile.Premiums) || [];
      
      if (this.client.clientProfile.PremiumType == 'TM') {
        this.medicareCoverageForm.controls['MedicarePartB'].setValue(premiums.MedicarePartB);
        this.medicareCoverageForm.controls['MedicarePartD'].setValue(premiums.MedicarePartD);
        this.medicareCoverageForm.controls['SupplimentalInsurance'].setValue(premiums.SupplimentalInsurance);
        this.medicareCoverageForm.controls['SupplementalPlan'].setValue(this.client.clientProfile.SelfSupplementalPlan);
        this.medicareCoverageForm.controls['DentalInsurance'].setValue(premiums.DentalInsurance);
      } else if (this.client.clientProfile.PremiumType == 'HMO') {
        this.medicareCoverageForm.controls['MedicareAdvantageHMO'].setValue(premiums.MedicareAdvantageHMO);
        this.medicareCoverageForm.controls['DentalInsurance'].setValue(premiums.DentalInsurance);
      } else  if (this.client.clientProfile.PremiumType == 'PPO') {
        this.medicareCoverageForm.controls['MedicareAdvantagePPO'].setValue(premiums.MedicareAdvantagePPO);
        this.medicareCoverageForm.controls['DentalInsurance'].setValue(premiums.DentalInsurance);
      }


      var oopCosts = JSON.parse(this.client.clientProfile.OOPCosts) || [];

      this.medicareCoverageForm.controls['HospitalAndTest'].setValue(oopCosts.HospitalAndTest);
      this.medicareCoverageForm.controls['PrescriptionDrugs'].setValue(oopCosts.PrescriptionDrugs);
      this.medicareCoverageForm.controls['HearingAndVisionCosts'].setValue(oopCosts.HearingAndVisionCosts);
      this.medicareCoverageForm.controls['DentalCosts'].setValue(oopCosts.DentalCosts);

      this.medicareCoverageForm.controls['IsSpouseSameHCSelection'].setValue(this.client.clientProfile.IsHSApplySpouse);
      this.isSpouseSameHCSelection = this.client.clientProfile.IsHSApplySpouse;



      // this.isShowSpouse = this.isEditAll ? (isMarried == 'true' ? true :false) :((isMarried == 'true')  && (this.client.clientProfile.Premiums != this.client.clientProfile.SpousePremiums|| this.client.clientProfile.PremiumType != this.client.clientProfile.PremiumType)? true: false);

      if (!this.client.clientProfile.IsHSApplySpouse && this.isShowSpouse) {
        this.spouseMedicareCoverageForm.controls['SpouseHealthCarePremiumType'].setValue ((this.client.clientProfile.SpousePremiumType) ? this.client.clientProfile.SpousePremiumType : "");
        this.changeSelection(this.isShowSpouse);
        var spousePremiums = JSON.parse(this.client.clientProfile.SpousePremiums) || [];
        if (this.client.clientProfile.SpousePremiumType == 'TM') {
          this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].setValue(spousePremiums.SpouseMedicarePartB);
          this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].setValue(spousePremiums.SpouseMedicarePartD);
          this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].setValue(spousePremiums.SpouseSupplimentalInsurance);
          this.spouseMedicareCoverageForm.controls['SpouseSupplementalPlan'].setValue(this.client.clientProfile.SpouseSupplementalPlan);
          this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].setValue(spousePremiums.SpouseDentalInsurance);
        } else if (this.client.clientProfile.SpousePremiumType == 'HMO') {
          this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].setValue(spousePremiums.SpouseMedicareAdvantageHMO);
          this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].setValue(spousePremiums.SpouseDentalInsurance);
        } else  if (this.client.clientProfile.SpousePremiumType == 'PPO') {
          this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].setValue(spousePremiums.SpouseMedicareAdvantagePPO);
          this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].setValue(spousePremiums.SpouseDentalInsurance);
        }
        var spouseOOPCosts = JSON.parse(this.client.clientProfile.SpouseOOPCosts) || [];
        this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].setValue(spouseOOPCosts.SpouseHospitalAndTest);
        this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].setValue(spouseOOPCosts.SpousePrescriptionDrugs);
        this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].setValue(spouseOOPCosts.SpouseHearingAndVisionCosts);
        this.spouseMedicareCoverageForm.controls['SpouseDentalCosts'].setValue(spouseOOPCosts.SpouseDentalCosts);
      }

    }

    if (this.params == 'income' || this.isEditAll) {
      console.log('here income');
      this.isOptionCurrentIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate != null && this.client.clientProfile.IRR) ? true : false;
      // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
      this.houseHoldYearOneIncome = this.client.clientProfile.HouseholdYearOneIncome ? this.client.clientProfile.HouseholdYearOneIncome : '';
      if ((this.isOptionCurrentIncome || this.houseHoldYearOneIncome) && this.client.clientProfile.Bracket == null) {
        // console.log('inflationRate', this.isOptionCurrentIncome);
        this.navCards[1].source = 'fromIncomeEnterSelected';
        this.isIncomeSelectionCard = 1;

        if (this.isOptionCurrentIncome) {
          this.selectOptions('currentIncome');
          // let currentIncome = Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0);          
          this.incomeEntryForm.controls['HouseHoldIncome'].setValue(!this.incomeEntryForm.value.HouseHoldIncome ? Utils.formatToCurrency(this.previousEnteredHousholdIncome): this.incomeEntryForm.value.HouseHoldIncome);
           this.incomeEntryForm.controls['IncomeInflationRate'].setValue(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.value.IncomeInflationRate == this.defaultIncomeInflationRate ?Utils.formatToPercentage(this.client.clientProfile.InflationRate): this.incomeEntryForm.value.IncomeInflationRate);
          this.incomeEntryForm.controls['IncomeReplacementRatio'].setValue(!this.incomeEntryForm.value.IncomeReplacementRatio ||  this.incomeEntryForm.value.IncomeReplacementRatio == this.defaultIncomeReplacementRatio ? Utils.formatToPercentage(this.client.clientProfile.IRR): this.incomeEntryForm.value.IncomeReplacementRatio);
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
            this.isOptionCurrentIncome = false;        
           }
        } else {
          this.selectOptions('houseHoldIncome');
          // console.log('this.houseHoldYearOneIncome', this.houseHoldYearOneIncome);
         this.incomeEntryForm.controls['YearOneRetirementIncome'].setValue(!this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.formatToCurrency(this.houseHoldYearOneIncome): this.incomeEntryForm.value.YearOneRetirementIncome);
        }       

      } else {
        var prop = 'currentIncome';
        if (this.client.clientProfile.Spouses[0][prop]) {
          console.log('exits')
          delete this.client.clientProfile.Spouses[0][prop];
        }

        let bracket = this.client.clientProfile.Bracket ? this.client.clientProfile.Bracket.toString(): '';
        this.incomeRangeSelectionForm.controls['BracketValue'].setValue(bracket);
        this.incomeRangeSelectionForm.controls['BracketValue'].updateValueAndValidity();
        this.navCards[0].source = 'fromIncomeSourceSelected';
        this.isIncomeSelectionCard = 2;
      }
      if (this.client.clientProfile.InRetirementInflationRate != null) {
        this.additinalIncomeForm.controls['InRetInflationRate'].setValue(Utils.formatToPercentage(this.client.clientProfile.InRetirementInflationRate));
      }
      if (this.client.clientProfile.MAGIPercentIncome) {
        this.additinalIncomeForm.controls['MAGIPerc'].setValue(Utils.formatToPercentage(this.client.clientProfile.MAGIPercentIncome));
      }
      if (this.client.midRetirementAdj) {
        if (this.client.midRetirementAdj.Year) {
          this.additinalIncomeForm.controls['RetAdjYear'].setValue(this.client.midRetirementAdj.Year);
        }
        if (this.client.midRetirementAdj.ReductionDollar) {
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].setValue(Utils.formatToCurrency(this.client.midRetirementAdj.ReductionDollar));
        }
        if (this.client.midRetirementAdj.ReductionPerc) {
          this.additinalIncomeForm.controls['RetAdjReductionPerc'].setValue(Utils.formatToPercentage(this.client.midRetirementAdj.ReductionPerc));
        }
        if (this.client.midRetirementAdj.IncomeInflationRate != null) {
          this.additinalIncomeForm.controls['RetAdjReductionInflation'].setValue(Utils.formatToPercentage(this.client.midRetirementAdj.IncomeInflationRate));
        }
      }
    }

    if(this.isEditAll || this.params == 'additionalQuestions' || ((this.params == 'emptyAll' || this.params == 'empty') && this.client.additionalQuestion)) {
      let firm = this.client.additionalQuestion ? this.client.additionalQuestion.Firm : '';
      let planSponsor = this.client.additionalQuestion ? this.client.additionalQuestion.PlanSponsor : '';
      let wholeSaler = this.client.additionalQuestion ? this.client.additionalQuestion.Wholesaler : '';
      let sendReportTo = this.client.additionalQuestion ? this.client.additionalQuestion.SendReportTo : '';
      let repName = this.client.additionalQuestion ? this.client.additionalQuestion.RepName : '';
      let meetingReference = this.client.additionalQuestion ? this.client.additionalQuestion.MeetingReference : '';
      let reportRequestFrom = this.client.additionalQuestion ? this.client.additionalQuestion.ReportRequestFrom : '';
      this.additionalQuestionsForm.controls['Firm'].setValue(firm);
      this.additionalQuestionsForm.controls['PlanSponsor'].setValue(planSponsor);
      this.additionalQuestionsForm.controls['Wholesaler'].setValue(wholeSaler);
      this.additionalQuestionsForm.controls['SendReportTo'].setValue(sendReportTo);
      this.additionalQuestionsForm.controls['RepName'].setValue(repName);
      this.additionalQuestionsForm.controls['MeetingReference'].setValue(meetingReference);
      this.additionalQuestionsForm.controls['ReportRequestFrom'].setValue(reportRequestFrom);
    }

    this.changeSelection(this.isMarried);
  }

  incomeOptionOneSelection() {
    this.isOptionCurrentIncome = true;
    //this.incomeEntryForm.get("HouseHoldIncome").setValidators([Validators.required]);
    //this.incomeEntryForm.get("IncomeInflationRate").setValidators([Validators.required]);
    //this.incomeEntryForm.get("IncomeReplacementRatio").setValidators([Validators.required]);
    
    this.incomeEntryForm.get("HouseHoldIncome").updateValueAndValidity();
    this.incomeEntryForm.get("IncomeInflationRate").updateValueAndValidity();
    this.incomeEntryForm.get("IncomeReplacementRatio").updateValueAndValidity();

    this.incomeEntryForm.get("YearOneRetirementIncome").reset();

    this.incomeEntryForm.get("YearOneRetirementIncome").clearValidators();

    this.incomeEntryForm.get("YearOneRetirementIncome").updateValueAndValidity();
  }

  onChange(scenario) {
    if (scenario == 'insuranceOptions') {
      if(this.healthInsuranceForm.value.IsPrivateHealthInsurance == 'true'){
        this.healthInsuranceForm.get("CoverageType").setValidators([Validators.required]);
      } else {
        this.healthInsuranceForm.get("CoverageType").reset();
        this.healthInsuranceForm.get("CoverageType").clearValidators();
        this.healthInsuranceForm.get("CoverageType").updateValueAndValidity();
      }
    }
    if (scenario == 'spouseInsuranceOptions') {
      if(this.spouseHealthInsuranceForm.value.IsSpousePrivateHealthInsurance == 'true'){
        this.spouseHealthInsuranceForm.get("SpouseCoverageType").setValidators([Validators.required]);
      } else {
        this.spouseHealthInsuranceForm.get("SpouseCoverageType").reset();
        this.spouseHealthInsuranceForm.get("SpouseCoverageType").clearValidators();
        this.spouseHealthInsuranceForm.get("SpouseCoverageType").updateValueAndValidity();
      }
    }
  }
  
  onCheckBoxChange(scenario) {
    this.enableControls(scenario);
    console.log('scenario', scenario);
    if (scenario == 'client') {
      console.log('medicareCoverageForm.value.MedicarePartB', this.medicareCoverageForm.value.MedicarePartB)
      console.log('this.medicareCoverageForm.value.HealthCarePremiumType', this.medicareCoverageForm.value.HealthCarePremiumType);
      
      if(this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB){
        this.medicareCoverageForm.controls['SupplimentalInsurance'].setValue(false);
        this.medicareCoverageForm.controls['SupplimentalInsurance'].disable();     
        
        // if(!this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.DentalInsurance){
        //   this.medicareCoverageForm.controls['MedicarePartD'].setValue(1);
        //   this.medicareCoverageForm.controls['MedicarePartD'].enable();     
        // }
      } else {
        this.medicareCoverageForm.controls['SupplimentalInsurance'].enable();     
      }
      if (!this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['SupplimentalInsurance'].disable();
      }
      if (this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['MedicarePartB'].disable();
      }
      if (!this.medicareCoverageForm.value.MedicarePartB && this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['MedicarePartD'].disable();
      }

      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalInsurance'].disable();
      }

      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' 
      && !this.medicareCoverageForm.value.MedicareAdvantageHMO 
      && this.medicareCoverageForm.value.DentalInsurance 
      && !this.medicareCoverageForm.value.HospitalAndTest 
      && !this.medicareCoverageForm.value.PrescriptionDrugs 
      && !this.medicareCoverageForm.value.HearingAndVisionCosts 
      && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalInsurance'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.MedicareAdvantagePPO && this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalInsurance'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.MedicareAdvantageHMO && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.MedicareAdvantagePPO && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.MedicareAdvantageHMO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.MedicareAdvantagePPO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.MedicareAdvantageHMO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.MedicareAdvantagePPO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalCosts'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.MedicareAdvantageHMO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalCosts'].disable();
      }
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.MedicareAdvantagePPO && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['DentalCosts'].disable();
      }

      console.log('this.medicareCoverageForm.value.MedicareAdvantageHMO', this.medicareCoverageForm.value.MedicareAdvantageHMO);
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' 
      && this.medicareCoverageForm.value.MedicareAdvantageHMO 
      && !this.medicareCoverageForm.value.DentalInsurance 
      && !this.medicareCoverageForm.value.HospitalAndTest 
      && !this.medicareCoverageForm.value.PrescriptionDrugs 
      && !this.medicareCoverageForm.value.HearingAndVisionCosts 
      && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['MedicareAdvantageHMO'].disable();
        console.log('disable HMO');
      }

      console.log('this.medicareCoverageForm.value.MedicareAdvantagePPO', this.medicareCoverageForm.value.MedicareAdvantagePPO);
      if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' 
      && this.medicareCoverageForm.value.MedicareAdvantagePPO 
      && !this.medicareCoverageForm.value.DentalInsurance 
      && !this.medicareCoverageForm.value.HospitalAndTest 
      && !this.medicareCoverageForm.value.PrescriptionDrugs 
      && !this.medicareCoverageForm.value.HearingAndVisionCosts 
      && !this.medicareCoverageForm.value.DentalCosts) {
        this.medicareCoverageForm.controls['MedicareAdvantagePPO'].disable();
        console.log('disable PPO');
      }
    } else {

      if(this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB){
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].setValue(0);
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].disable();     
        
        // if(!this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance){
        //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].setValue(1);
        //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].enable();     
        // }
      } else {
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].enable();     
      }
      if (!this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].disable();
      }
      if (!this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' 
      && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO 
      && this.spouseMedicareCoverageForm.value.SpouseDentalInsurance 
      && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest 
      && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs 
      && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts
      && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' 
      && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO
      && this.spouseMedicareCoverageForm.value.SpouseDentalInsurance 
      && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest 
      && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs 
      && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts 
      && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'TM' && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartB && !this.spouseMedicareCoverageForm.value.SpouseMedicarePartD && !this.spouseMedicareCoverageForm.value.SpouseSupplimentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseDentalCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseDentalCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' && !this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts && this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.medicareCoverageForm.controls['SpouseDentalCosts'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'HMO' 
      && this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantageHMO 
      && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance 
      && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest 
      && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs 
      && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts 
      && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        console.log('here i am 02')
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].disable();
      }
      if (this.spouseMedicareCoverageForm.value.SpouseHealthCarePremiumType == 'PPO' 
      && this.spouseMedicareCoverageForm.value.SpouseMedicareAdvantagePPO  
      && !this.spouseMedicareCoverageForm.value.SpouseDentalInsurance 
      && !this.spouseMedicareCoverageForm.value.SpouseHospitalAndTest 
      && !this.spouseMedicareCoverageForm.value.SpousePrescriptionDrugs 
      && !this.spouseMedicareCoverageForm.value.SpouseHearingAndVisionCosts 
      && !this.spouseMedicareCoverageForm.value.SpouseDentalCosts) {
        this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].disable();
      }
      
    }
   

      // if (scenario == 'medciarePartB' ) {
      //   if (this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['MedicarePartB'].disable();
      //   }
      // }
      // if (scenario == 'medciarePartD' ) {
      //   if (!this.medicareCoverageForm.value.MedicarePartB && this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['MedicarePartD'].disable();
      //   }
      // }
      // if (scenario == 'supplimentalInsurance' ) {
      //   if (!this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['SupplimentalInsurance'].disable();
      //   }
      // }
      // if (scenario == 'dentalInsurance') {
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalInsurance'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalInsurance'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalInsurance'].disable();
      //   }
      // }
      // if (scenario == 'hospitalAndTest') {
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.DentalInsurance && this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HospitalAndTest'].disable();
      //   }
      // }
      // if (scenario == 'prescriptionDrugs') {
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['PrescriptionDrugs'].disable();
      //   }
      // }
      // if (scenario == 'hearingAndVisionCosts') {
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && this.medicareCoverageForm.value.HearingAndVisionCosts && !this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['HearingAndVisionCosts'].disable();
      //   }
      // }
      // if (scenario == 'dentalCosts') {
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'TM' && !this.medicareCoverageForm.value.MedicarePartB && !this.medicareCoverageForm.value.MedicarePartD && !this.medicareCoverageForm.value.SupplimentalInsurance && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalCosts'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'HMO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalCosts'].disable();
      //   }
      //   if (this.medicareCoverageForm.value.HealthCarePremiumType == 'PPO' && !this.medicareCoverageForm.value.DentalInsurance && !this.medicareCoverageForm.value.HospitalAndTest && !this.medicareCoverageForm.value.PrescriptionDrugs && !this.medicareCoverageForm.value.HearingAndVisionCosts && this.medicareCoverageForm.value.DentalCosts) {
      //     this.medicareCoverageForm.controls['DentalCosts'].disable();
      //   }
      // }
  }

  enableControls(scenario) {
    if (scenario == 'client') {
      // if (this.isPre65) {
      //   this.medicareCoverageForm.controls['MedicarePartB'].disable();
      //   this.medicareCoverageForm.controls['MedicarePartD'].disable();
      //   this.medicareCoverageForm.controls['SupplimentalInsurance'].disable();
      //   this.medicareCoverageForm.controls['MedicareAdvantageHMO'].disable();
      //   this.medicareCoverageForm.controls['MedicareAdvantagePPO'].disable();
      // } else {
      //   this.medicareCoverageForm.controls['MedicarePartB'].enable();
      //   this.medicareCoverageForm.controls['MedicarePartD'].enable();
      //   this.medicareCoverageForm.controls['SupplimentalInsurance'].enable();
      //   this.medicareCoverageForm.controls['MedicareAdvantageHMO'].enable();
      //   this.medicareCoverageForm.controls['MedicareAdvantagePPO'].enable();
      // }
      this.medicareCoverageForm.controls['MedicarePartB'].enable();
      this.medicareCoverageForm.controls['MedicarePartD'].enable();
      this.medicareCoverageForm.controls['SupplimentalInsurance'].enable();
      this.medicareCoverageForm.controls['MedicareAdvantageHMO'].enable();
      this.medicareCoverageForm.controls['MedicareAdvantagePPO'].enable();

      this.medicareCoverageForm.controls['DentalInsurance'].enable();
      this.medicareCoverageForm.controls['HospitalAndTest'].enable();
      this.medicareCoverageForm.controls['PrescriptionDrugs'].enable();
      this.medicareCoverageForm.controls['HearingAndVisionCosts'].enable();
      this.medicareCoverageForm.controls['DentalCosts'].enable();
    } else {
      // if (this.isSpousePre65) {
      //   console.log('here am i 01');
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].disable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].disable();
      //   this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].disable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].disable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].disable();
      // } else {
      //   console.log('here am i 02');
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].enable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].enable();
      //   this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].enable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].enable();
      //   this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].enable();
      // }
      this.spouseMedicareCoverageForm.controls['SpouseMedicarePartB'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseMedicarePartD'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseSupplimentalInsurance'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantageHMO'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseMedicareAdvantagePPO'].enable();

      this.spouseMedicareCoverageForm.controls['SpouseDentalInsurance'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseHospitalAndTest'].enable();
      this.spouseMedicareCoverageForm.controls['SpousePrescriptionDrugs'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseHearingAndVisionCosts'].enable();
      this.spouseMedicareCoverageForm.controls['SpouseDentalCosts'].enable();
    }
  }

  get MedicareAdvantageHMO() {
    return this.medicareCoverageForm.get('MedicareAdvantageHMO') as FormControl;
  }
  get MedicareAdvantagePPO() {
    return this.medicareCoverageForm.get('MedicareAdvantagePPO') as FormControl;
  }
  get DentalInsurance() {
    return this.medicareCoverageForm.get('DentalInsurance') as FormControl;
  }
  get HospitalAndTest() {
    return this.medicareCoverageForm.get('HospitalAndTest') as FormControl;
  }
  get PrescriptionDrugs() {
    return this.medicareCoverageForm.get('PrescriptionDrugs') as FormControl;
  }
  get HearingAndVisionCosts() {
    return this.medicareCoverageForm.get('HearingAndVisionCosts') as FormControl;
  }
  get DentalCosts() {
    return this.medicareCoverageForm.get('DentalCosts') as FormControl;
  }

  updateValue(i, newValue) {
    console.log('i', i);
    console.log('newValue', newValue);
    console.log('this.mmtModalData01', this.mmtModalData);
    this.isMAGIUpdate = true;
    newValue = Utils.removeCurrencyFormatting(newValue);
    newValue = newValue == 0 ? '': newValue;
    this.mmtModalData[i].percentMAGI = this.formatCurrency(newValue, '');
    this.mmtModalData[i].updatedBracket = this.bracketAssign(newValue);
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['percentMAGI'].patchValue(this.mmtModalData[i].percentMAGI);
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['updatedBracket'].patchValue(this.mmtModalData[i].updatedBracket);
    console.log('this.mmtModalData02', this.mmtModalData);

  }

  bracketAssign(percentMAGI) {
    let bracketValue;
    if (percentMAGI >= this.magiBracketOneMin && percentMAGI <= this.magiBracketOneMax) {
      bracketValue = 1;
    }
    if (percentMAGI >= this.magiBracketTwoMin && percentMAGI <= this.magiBracketTwoMax) {
      bracketValue = 2;
    }
    if (percentMAGI >= this.magiBracketThreeMin && percentMAGI <= this.magiBracketThreeMax) {
      bracketValue = 3;
    }
    if (percentMAGI >= this.magiBracketFourMin && percentMAGI <= this.magiBracketFourMax) {
      bracketValue = 4;
    }
    if (percentMAGI >= this.magiBracketFiveMin && percentMAGI <= this.magiBracketFiveMax) {
      bracketValue = 5;
    }
    if (percentMAGI >= this.magiBracketSixMin && percentMAGI <= this.magiBracketSixMax) {
      bracketValue = 6;
    }
    return bracketValue;


  }
}



